import { DropdownField, NumberField } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';

import { getDefaultTravelTimeForType } from '../../../../utils/underground';
import { FieldBlurificator } from '../../../../common/components/field_blurificator';
import { EMetroTravelType } from '../../../../json_query';
import { InlineBlock, InlineLabel } from '../../advanced/markup';

const style = require('./index.css');

type NumberFieldBlurificator = new () => FieldBlurificator<number | undefined>;
const NumberFieldBlurificator = FieldBlurificator as NumberFieldBlurificator;

export interface IMetroHeaderProps {
  minutes?: number;
  onRing?: boolean;
  insideRing?: boolean;

  travelType: EMetroTravelType;
  travelTime: number | undefined;

  fastSelectionButtons: React.ReactNode;

  onUndergroundTravelChanged(travelType: EMetroTravelType, travelTime: number | undefined): void;
}

export class MetroModalHeader extends React.Component<IMetroHeaderProps> {
  public render() {
    const travelTime = this.props.travelTime || getDefaultTravelTimeForType(this.props.travelType);

    return (
      <div className={style['header']}>
        <div className={style['label']}>Расстояние до метро:</div>
        <DropdownField
          value={this.props.travelType}
          onValueChange={(value: EMetroTravelType) =>
            this.props.onUndergroundTravelChanged(value, this.props.travelTime || getDefaultTravelTimeForType(value))
          }
          values={[
            { value: EMetroTravelType.Any, label: 'неважно' },
            { value: EMetroTravelType.MapFoot, label: 'пешком' },
            { value: EMetroTravelType.MapTransport, label: 'транспортом' },
          ]}
        />
        {this.props.travelType !== EMetroTravelType.Any && (
          <div className={style['minutesWrapper']}>
            <InlineLabel>Не более:</InlineLabel>
            <InlineBlock customStyles={style['minutes']}>
              <NumberField
                disableFractional
                disableNegative
                inputStyle={{ width: '60px' }}
                value={travelTime}
                onValueChange={(value: number | undefined) =>
                  this.props.onUndergroundTravelChanged(this.props.travelType, value)
                }
              />
            </InlineBlock>
            <InlineLabel>{plural(travelTime, ['минута', 'минуты', 'минут'])}</InlineLabel>
          </div>
        )}
        <div className={style['buttons']}>{this.props.fastSelectionButtons}</div>
      </div>
    );
  }
}
